import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import * as image from "../../resources/images";
import { getSequnceSort } from "../../utils/helper";
import Vicky from "../controls/Vicky";
import { selectOptionData } from "../../redux/actions";
const ShowNuggetPopup = ({ closeNugget, modalData }) => {
	const dispatch = useDispatch();

	// console.log("ShowNuggetPopup @@@@", modalData);
	return (
		<div className="NuggetPopup downgradepopup RootContent my_popup newuipopupchanges">
			<div className="NuggetPopupTitle  flex modal-header">
				<div className="w-100">
					<h5 className="flexone w-100">
				    	<span>
						<img src={image.nuggetsicon} alt="" className="mr-2" />
						{modalData?.title}
						</span>
					<button className="closebtn" data-dismiss="modal" onClick={() => closeNugget()}>
					  <i className="fa-regular fa-xmark m-0"></i>
				   </button>
					</h5>
				</div>
				
			</div>
			<div className="NuggetPopupDesc d-flex align-items-start justify-content-between pt-1">
				<div className="NugeetsSolution w-100">
				    <h6 className="mt-4">Your Answer</h6>
					{
						modalData?.optNuggetData?.map((option, index) => (
							<div className="otherOptionssol" key={index}>
								<p>
									<div className="nuggetsolitems">
										<h4 className={`${option?.isCorrect ? "option_ans" : "option_ans option_wrongans"} fw-600`}>
											{/* <strong>
												{" "}
												Option {`${option?.sequence}`}:
											</strong>{" "} */}
											{/* <span
											dangerouslySetInnerHTMLL={{
											__html: option?.question,
											}}
											/> */}
											<img src={image.Radio_Button} className="mr-3" />
											{option?.question}{" "}
										</h4>
										<div className="reason_ mb-3">
										<h6 className="position-relative">Reasoning
										<Vicky
										text={
											"option " +
											option?.sequence +
											" ..." +
											option?.question +
											"  ..." +
											option?.help
										}
										id={option?.sequence}
									// data={data}
									/>
										</h6>
										<p
											dangerouslySetInnerHTML={{
												__html: option?.help,
											}}
										/>{" "}
										</div>
									</div>
									
								</p>
							
							</div>
						))
					}
					{!modalData?.questionData?.options?.every((item) => item?.isUserSelected) && modalData?.questionData?.attempted && (
						<React.Fragment>
							<h5>
								Nice work! But here are the other choices
								you haven’t seen, to get some better
								insight...
							</h5>
						
						</React.Fragment>
					)}
					{modalData?.questionData?.attempted && (
						getSequnceSort(modalData?.questionData?.options)?.map(
							(option, optionIndex) =>
								!option?.isUserSelected && (
									<React.Fragment key={optionIndex}>
									 <h6 className="mt-4">Option {`${option?.sequence}`}</h6>
										<div className="otherOptionssol">
											<p>
												<div className="nuggetsolitems">
													<h4 className="option_ans fw-600 option_wrongans">
														{/* <strong>
															{" "}
															
														</strong>{" "} */}
														<img src={image.Radio_Button} className="mr-3" />
														<span
															dangerouslySetInnerHTML={{
																__html: option?.question,
															}}
														/>{" "}
													</h4>
													<div className="reason_">
														<h6 className="position-relative">Reasoning
								                          	<Vicky
													text={
														"option " +
														option?.sequence +
														" ..." +
														option?.question +
														"  ..." +
														option?.help
													}
													id={option?.sequence}
												// data={data}
												/>
									                 	</h6>
															<p
														dangerouslySetInnerHTML={{
															__html: option?.help,
														}}
													/>{" "}
													</div>
												
												</div>
											
											</p>
											
										</div>
									</React.Fragment>
								)
						)
					)}
				</div>
			</div>
			<div className="NuggetPopupFooter d-flex modal-footer w-100 mt-4">
				
					<div className="flexone pl-2 haveAttempts w-100">
					   	{modalData?.title === "Well Done!" ? (
                             <span className="greatjobtxt flexone">
                             <img src={image.greatjob} className="mr-2" />
                                Great Job ! 
                            </span>
                    ) : (
                        <span className="keeptrying flexone">
                        <img src={image.thumb_hands} className="mr-2" />
                        Keep Trying You’ll Get It Right
                       </span>
                    )}
						{!modalData?.questionData?.attempted && (
                        <span className="AttemsQuestion">
                        <span className="mr-1">
                        {3 - modalData?.questionData?.invalidAttempt} / 3
                         </span>
                        Attempt{(3 - modalData?.questionData?.invalidAttempt) > 1 ? 's' : ''} Left
                         </span>
                    )}
							{/* {
								!modalData?.questionData?.attempted && (
									<p className="flexone">
										<img src={image.exclamationTrangle} className="mr-2" />
										You have {3 - modalData?.questionData?.invalidAttempt} more attempt{(3 - modalData?.questionData?.invalidAttempt) > 1 ? 's' : ''} left.
									</p>
								)
							} */}
						</div>
						{/* <button
							type="button"
							className="btn-blue btn-login d-block mb-5 ml-auto mr-2 cancelbutton"
							onClick={() => closeNugget()}
						>
							<span
							key={
								data?.kc?.length > 0 &&
								data?.kc[selectedQuestionIndex].id
							}
							>
								<i className="fa-solid fa-xmark mr-2"></i>
							</span>
							Close
						</button> */}
		            	</div>
		               </div>
	);
}
export default ShowNuggetPopup;